import React from "react";

const StatusMessage = ({ formError }) => {
  if (formError) {
    return (
      <div className="bg-red-50 border border-red-200 rounded-sm p-4 mb-6">
        <p className="text-red-800 text-sm">{formError}</p>
      </div>
    );
  }
  return null;
};

export default StatusMessage;